<template>

    <div >
      <v-dialog v-model="imageDialog" width="600px">
        <v-card width="600px">
            <!-- <v-card-text style="margin: -10px;"> -->
                <v-sheet
                    :elevation="10"
                    style="margin: 10px;"
                    
                >
                    <v-img
                        class="align-end text-white"
                        
                        :src="srcImage"
                        cover
                    >
                    <v-card-title>
                      <v-chip   class="dimension-vatican">{{ `Photo ${indexPhoto.index+1}/${props.photosTab.PhotosCount}` }}</v-chip>
                      <v-chip   class="dimension-vatican">{{ ` ${props.article.reference_y2} - ${props.photosTab.photos[indexPhoto.index].couleur?props.photosTab.photos[indexPhoto.index].couleur:store.state.itemColors.find(el=> {return el.substring(0,2)==props.article.reference_y2.substring(10,13)}) }` }}</v-chip>
                      
                    </v-card-title>
                    </v-img>
                </v-sheet>

            <v-card-actions class="my-2 d-flex justify-space-between">
                <v-btn
                  v-if="props.photosTab.PhotosCount>1"
                  class="text-none"
                  rounded="xl"
                  text="Précédent"
                  @click="indexPhoto.type='photo';(indexPhoto.index<=0?(indexPhoto.index=props.photosTab.photos.length-1):indexPhoto.index--);getPhoto(props.photosTab.photos[indexPhoto.index])"
                  color="primary"
                ></v-btn>
                <v-btn
                  class="text-none"
                  rounded="xl"
                  text="Fermer"
                  color="danger"
                  @click="imageDialog=false"
                ></v-btn>
                <v-btn
                  v-if="props.photosTab.PhotosCount>1"
                  class="text-none"
                  color="primary"
                  rounded="xl"
                  text="Suivant"
                  @click="indexPhoto.type='photo';(indexPhoto.index>props.photosTab.photos.length-2?(indexPhoto.index=0):indexPhoto.index++);getPhoto(props.photosTab.photos[indexPhoto.index])"
                ></v-btn>
                <!-- variant="flat" -->
              </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

</template>
<script setup>
import { ref,onMounted,computed  } from 'vue';
import axios from 'axios'
import store from '../store';
// import { onMounted,  } from 'vue';
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  article:{
    type: Object
  },
  photosTab:{
    type: Object
  }
})

// Événements
const emit = defineEmits(['update:modelValue', 'validate'])

// Référence du dialogue
const imageDialog = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})



// let imageDialog=ref(false)
let indexPhoto=ref({
    type:'photo',
    index:props.photosTab.index || 0
})

let srcImage=ref()
async  function getPhoto (el){
  if(props.photosTab.srcImage){
    srcImage.value=`https://www.edisac.com/images/article_la/${el.photo}` 
  }else{
    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getphoto',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    params : {photo:el}
    }

    return axios.request(config)
    .then((response) => { 
        srcImage.value=response.data
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }
    
}
onMounted(()=>{
    getPhoto (props.photosTab.firstPhoto)   
})
</script>
<style scoped>
.dimension-vatican {
    font-family: 'Times New Roman', 'Georgia', serif;
    font-style: italic;
    /* background-color: antiquewhite; */
    color: black
    
}
</style>